// Copyright (c) Microsoft. All rights reserved.

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState, PluginsState, PluginAPI } from '../../../libs/models/app/Plugin';

export const pluginSlice = createSlice({
  name: 'plugin',
  initialState,
  reducers: {
    addPlugin: (state: PluginsState, action: PayloadAction<PluginAPI>) => {
      const newId = action.payload.id;
      state.plugins = { ...state.plugins, [newId]: action.payload };
    },
    setSelectedPlugin: (state: PluginsState, action: PayloadAction<string | null>) => {
      if (action.payload !== null) {
        const plugin: PluginAPI = state.plugins[action.payload];
        state.selectedPlugin = plugin;
      } else {
        state.selectedPlugin = null;
      }
    },
    setSelectedPlugins: (state: PluginsState, action: PayloadAction<PluginAPI>) => {
      state.selectedPlugin = action.payload;
    },
    setPluginInputValues: (state: PluginsState, action: PayloadAction<Record<string, string>>) => {
      state.inputValues = action.payload;
    },
    setPluginInputFormVisible: (state: PluginsState, action: PayloadAction<boolean>) => {
      state.isInputFormVisible = action.payload;
    },
    resetPluginInput: (state: PluginsState) => {
      state.inputValues = {};
      state.isInputFormVisible = false;
    }
    // 사용할 플러그인 connect / disconnect 로직인듯
    // connectPlugin: (state: PluginsState, action: PayloadAction<EnablePluginPayload>) => {
    //     const plugin: Plugin = state.plugins[action.payload.plugin];
    //     let authData = action.payload.accessToken;

    //     switch (action.payload.plugin) {
    //         case BuiltInPlugins.Jira.valueOf():
    //             authData = `${action.payload.email as string}:${action.payload.accessToken as string}`;
    //             break;
    //         default:
    //             // Plugins requiring no auth
    //             if (!authData || authData === '') {
    //                 authData = `${plugin.headerTag}-auth-data`;
    //             }
    //     }

    //     plugin.enabled = true;
    //     plugin.authData = authData;
    //     plugin.apiProperties = action.payload.apiProperties;
    // },
    // disconnectPlugin: (state: PluginsState, action: PayloadAction<string>) => {
    //     const plugin = state.plugins[action.payload];
    //     plugin.enabled = false;
    //     plugin.authData = undefined;
    //     const apiProperties = plugin.apiProperties;
    //     if (apiProperties) {
    //         Object.keys(apiProperties).forEach((key) => {
    //             apiProperties[key].value = undefined;
    //         });
    //     }
    // },
  },
});

export const { setSelectedPlugin, addPlugin, setSelectedPlugins, setPluginInputValues, setPluginInputFormVisible, resetPluginInput } = pluginSlice.actions;

export default pluginSlice.reducer;
